import { Event } from '@domain/event';

export const OFFER_TAB_PARAM = 'offerTab';

export const TAB_ADMISSION = 'admissions';
export const TAB_FLOORPLAN = 'floorplan';
export const TAB_ADDON = 'addon';
export const TAB_PASS = 'pass';
export const TAB_INVITATIONS = 'invitation';
export const TAB_SETTINGS = 'settings';

/**
 * The Settings tab used to be the Pre-registration tab. Bookmarks and shared links still carry the old
 * `?offerTab=preRegistration`, so it is accepted on read and never written back.
 */
export const LEGACY_TAB_PRE_REGISTRATION = 'preRegistration';

export interface Props {
  event: Event;
  openFloorplanModal: () => void;
}
